<template>
  <div class="approve">
    <div class="approvetitle">
      <svg-icon icon-class="shizhong"></svg-icon>
      等**我办理
    </div>
    <MyTitle title="基本信息"></MyTitle>
    <div class="dataBox">
      <div class="item">
        <div class="label">单据编号</div>
        <div class="text">{{ addForm.applyNum }}</div>
      </div>
      <div class="item">
        <div class="label">申请人</div>
        <div class="text">{{ addForm.employeeName }}</div>
      </div>
      <div class="item">
        <div class="label">申请人工号</div>
        <div class="text">{{ addForm.employeeCode }}</div>
      </div>
      <div class="item">
        <div class="label">申请人岗位</div>
        <div class="text">{{ addForm.positionName }}</div>
      </div>
      <div class="item">
        <div class="label">申请人公司</div>
        <div class="text">{{ addForm.salaryCompany }}</div>
      </div>
      <div class="item">
        <div class="label">申请人部门</div>
        <div class="text">{{ addForm.department }}</div>
      </div>
      <div class="item">
        <div class="label">人员成本分类</div>
        <div class="text">{{ addForm.costClassification }}</div>
      </div>
      <div class="item">
        <div class="label">申请日期</div>
        <div class="text">{{ addForm.createTime }}</div>
      </div>
      <div class="item">
        <div class="label">员工等级</div>
        <div class="text">{{ addForm.levelExplain }}</div>
      </div>
    </div>
    <MyTitle title="工作流信息"></MyTitle>
    <div class="dataBox">
      <div class="item">
        <div class="label">工作流名称</div>
        <div class="text">{{ addForm.workflowName }}</div>
      </div>
      <!-- <div class="item">
        <div class="label">所属财务部</div>
        <div class="text">{{ addForm.financeName }}</div>
      </div> -->
      <div class="item" v-if="workflow != 0 && workflow != 4">
        <div class="label">支付方式</div>
        <div class="text">{{ addForm.paywayName }}</div>
      </div>
      <div class="item" v-if="workflow == 1">
        <div class="label">最高随行人</div>
        <div class="text">{{ addForm.topEntourage }}</div>
      </div>
      <div class="item" v-if="addForm.workflow != 4">
        <div class="label">币种</div>
        <div class="text">{{ addForm.currencyName }}</div>
      </div>
      <div class="item" v-if="workflow != 0 && workflow != 4">
        <div class="label">收款方</div>
        <div class="text">{{ addForm.payeeCombination }}</div>
      </div>
      <div class="item" v-if="workflow == 3">
        <div class="label">是否冲借支</div>
        <div class="text">{{ addForm.isBorrow?"是":"否" }}</div>
      </div>
      <div class="item" v-if="workflow == 3">
        <div class="label">是否行政相关</div>
        <div class="text">{{ addForm.isAdministrative?"是":"否" }}</div>
      </div>
      <div class="item" v-if="workflow == 3">
        <div class="label">是否通讯费相关</div>
        <div class="text">{{ addForm.isCommunication?"是":"否" }}</div>
      </div>
      <div class="item" v-if="workflow == 0 || workflow == 1 || workflow == 4">
        <div class="label">出差类型</div>
        <div class="text">{{ addForm.travelTypeName }}</div>
      </div>
      <!-- <div class="item" v-if="workflow != 0 && workflow != 4">
        <div class="label">费用承担部门</div>
        <div class="text">{{ addForm.expenseDepartName }}</div>
      </div> -->
      <div class="item" v-if="workflow != 0 && workflow != 4">
        <div class="label">预算单位</div>
        <div class="text">{{ addForm.budgetUnit }}</div>
      </div>
      <div class="item" v-if="workflow == 11">
        <div class="label">是否无票</div>
        <div class="text" v-show="addForm.haveInvoice == 1">是</div>
        <div class="text" v-show="addForm.haveInvoice == 0">否</div>
      </div>
      <div class="item" v-if="workflow == 2 || workflow == 3|| workflow == 5|| workflow == 6|| workflow == 7|| workflow == 9">
        <div class="label">费用类型</div>
        <div class="text">{{ addForm.costName }}</div>
      </div>
      <div class="item" v-if="workflow == 13">
        <div class="label">借支类型</div>
        <div class="text">{{ addForm.borrowTypeName }}</div>
      </div>
      <div class="item" v-if="workflow == 13 && addForm.borrowType == 1">
        <div class="label">投标公司</div>
        <div class="text">{{ addForm.biddingCompany }}</div>
      </div>
      <div class="item" v-if="workflow == 13 && addForm.borrowType == 2">
        <div class="label">客户名称</div>
        <div class="text">{{ addForm.biddingCompany }}</div>
      </div>
      <div class="item" v-if="workflow == 13">
        <div class="label">本次借款金额</div>
        <div class="text">{{ addForm.applyAmount }}</div>
      </div>
      <div class="item" v-if="workflow == 1 || workflow == 0">
        <div class="label">开始日期</div>
        <div class="text">{{ addForm.leaveTime }}</div>
      </div>
      <div class="item" v-if="workflow == 1 || workflow == 0">
        <div class="label">结束日期</div>
        <div class="text">{{ addForm.returnTime }}</div>
      </div>
      <div class="item" v-if="workflow == 4">
        <div class="label">出发日期</div>
        <div class="text">{{ addForm.leaveTime }}</div>
      </div>
      <div class="item" v-if="workflow == 4">
        <div class="label">返回日期</div>
        <div class="text">{{ addForm.returnTime }}</div>
      </div>
      <div class="item" v-if="workflow == 11 || workflow == 9">
        <div class="label">开始时间</div>
        <div class="text">{{ addForm.leaveTime }}</div>
      </div>
      <div class="item" v-if="workflow == 11 || workflow == 9">
        <div class="label">结束时间</div>
        <div class="text">{{ addForm.returnTime }}</div>
      </div>
      <div class="item" v-if="workflow == 9 && String(addForm.costName).indexOf('防暑降温费')!=-1">
        <div class="label">气温情况</div>
        <div class="text">{{ addForm.dictKeyName }}</div>
      </div>
      <div class="item" v-if="workflow == 9 && String(addForm.costName).indexOf('生活费用')!=-1">
        <div class="label">发生季度</div>
        <div class="text">{{ addForm.dictKeyName }}</div>
      </div>
      <div class="item" v-if="workflow == 11">
        <div class="label">城市</div>
        <div class="text">{{ addForm.city }}</div>
      </div>
      <div class="item" v-if="workflow == 11">
        <div class="label">人数</div>
        <div class="text">{{ addForm.number }}</div>
      </div>
      <div class="item" v-if="workflow == 9">
        <div class="label">数量</div>
        <div class="text">{{ addForm.number }}</div>
      </div>
      <div class="item" v-if="workflow == 11|| workflow == 9">
        <div class="label">单价</div>
        <div class="text">{{ addForm.price }}</div>
      </div>
      <div class="item" v-if="workflow == 0">
        <div class="label">始发地</div>
        <div class="text">{{sf}}</div>
      </div>
      <div class="item" v-if="workflow == 0">
        <div class="label">目的地</div>
        <div class="text">{{md}}</div>
      </div>
      <div class="item" v-if="workflow == 0 || workflow == 1">
        <div class="label">出差路径</div>
        <div class="text">{{ addForm.itinerary }}</div>
      </div>
      <div class="item">
        <div class="label">申请事由及说明</div>
        <div class="text">{{ addForm.applyReason }}</div>
      </div>
    </div>
    <MyTitle title="单据关联" v-if="addForm.workflow == 1||addForm.workflow == 3"></MyTitle>
    <div class="dataBox" v-if="addForm.workflow == 1||addForm.workflow == 3">
      <div class="item">
        <div class="label">关联事前申请单</div>
        <div class="text">{{ addForm.advanceApplyNum }}</div>
      </div>
      <div class="item">
        <div class="label">金额</div>
        <div class="text">{{ addForm.advanceApplyAmountStr }}</div>
      </div>
    </div>
    <MyTitle title="超标申请" v-if="addForm.workflow == 1"></MyTitle>
    <div class="dataBox" v-if="addForm.workflow == 1">
      <div class="item">
        <div class="label">是否超标</div>
        <div class="text" v-if="addForm.isExcess == 0">否</div>
        <div class="text" v-if="addForm.isExcess == 1">是</div>
      </div>
      <div class="item">
        <div class="label">超标申请</div>
        <div class="text">{{ addForm.excessApplyNum }}</div>
      </div>
    </div>
    <MyTitle
      title="入账子公司"
      v-if="
        addForm.workflow == '1' ||
        addForm.workflow == '2' ||
        addForm.workflow == '3' ||
        addForm.workflow == '5' ||
        addForm.workflow == '6' ||
        addForm.workflow == '7' ||
        addForm.workflow == '8' ||
        addForm.workflow == '9'
      "
    ></MyTitle>
    <div
      class="gridBox"
      v-if="
        addForm.workflow == '1' ||
        addForm.workflow == '2' ||
        addForm.workflow == '3' ||
        addForm.workflow == '5' ||
        addForm.workflow == '6' ||
        addForm.workflow == '7' ||
        addForm.workflow == '8' ||
        addForm.workflow == '9'
      "
    >
      <van-grid
        column-num="2"
        v-if="
          $route.query.type == 'approve' &&
          $route.query.approveType == 'receiptApproval'
          && addForm.subsidiarySource !=1 
        "
      >
        <van-grid-item>
          <div class="item">
            <div class="title">入账子公司</div>
            <van-cell is-link @click="$router.push('/bookingSubsidiary')">{{
              addForm.bookingSubsidiary 
            }}</van-cell>
          </div>
        </van-grid-item>
      </van-grid>
      <div class="item2" v-else>
        <div class="label">入账子公司</div>
        <div class="text">{{ addForm.bookingSubsidiary }}</div>
      </div>
    </div>
    <MyTitle title="费用明细"></MyTitle>
    <van-tabs v-model="active" @click="tabClick">
      <!-- <van-tab
        title="发票夹"
        name="发票夹"
        v-if="workflow == 11 && !addForm.haveInvoice"
      ></van-tab> -->
      <van-tab
        title="发票夹"
        name="发票夹"
        v-if="workflow != 0 && workflow != 4&& workflow != 13"
      ></van-tab>
      <van-tab
        title="明细信息"
        name="明细信息"
        v-if="workflow != 4&& workflow != 13"
      ></van-tab>
      <van-tab title="附件信息" name="附件信息"></van-tab>
    </van-tabs>
    <!-- <DetailInformation
      v-show="active == 0"
      :data="detailInformationData"
    ></DetailInformation> -->
    <!-- <InvoiceClip
      v-show="active == 1"
      :data="detailInformationData"
    ></InvoiceClip> -->
    <!-- <Attachment v-show="active == 2" :data="detailInformationData"></Attachment> -->
    <!-- 明细信息 -->
    <van-swipe ref="swiper" duration="500" :loop="false" @change="swiperChange">
      <van-swipe-item v-if="workflow != 0 && workflow != 4&& workflow != 13">
        <!-- 发票 -->
        <div class="gridBox" style="background: #fff">
          <div v-for="(item, index) in detailInformationData" :key="index">
            <div class="tabContro van-hairline--bottom">
              <div class="tit">发票({{index+1}})</div>
              <div
                class="del"
                @click="
                  $api.look({ filePath: item.filePath, fileName: item.fileName })
                "
              >
                查看
              </div>
            </div>
            <div class="essentialInformation">
              <div>
                <div class="label">票据类型</div>
                <div class="text">{{ item.invoiceTypeName }}</div>
              </div>
              <div>
                <div class="label">发票号码</div>
                <div class="text">{{ item.invoiceNumber }}</div>
              </div>
              <div>
                <div class="label">发票服务名称</div>
                <div class="text">{{ item.goodsName }}</div>
              </div>
              <div>
                <div class="label">发票代码</div>
                <div class="text">{{ item.invoiceCode }}</div>
              </div>
              <div>
                <div class="label">不含税金额</div>
                <div class="text">{{ item.noTaxAmountStr }}</div>
              </div>
              <div>
                <div class="label">税率</div>
                <div class="text">{{ item.taxRate }}</div>
              </div>
              <div>
                <div class="label">税额</div>
                <div class="text">{{ item.taxAmountStr }}</div>
              </div>
              <div>
                <div class="label">价税合计</div>
                <div class="text">{{ item.totalAmountStr }}</div>
              </div>
              <div>
                <div class="label">本次报销金额</div>
                <div class="text">{{ item.amountStr }}</div>
              </div>
              <div>
                <div class="label">说明</div>
                <div class="text">{{ item.costDescription }}</div>
              </div>
            </div>
          </div>
        </div>
      </van-swipe-item>
      <van-swipe-item v-if="workflow != 4&& workflow != 13">
        <!-- 附件信息 -->
        <div class="approveTabContro">
        <div
            class="gridBox"
            v-for="(item, index) in detailInformationData"
            :key="index"
          >
            <div class="tabContro">
              <div class="tit">明细信息({{ index + 1 }})</div>
            </div>
            <van-grid column-num="2">
              <van-grid-item v-if="workflow == 1 || workflow == 8">
                <div class="item">
                  <div class="title requiredColum">费用类型</div>
                  <van-cell is-link >{{
                    item.costName 
                  }}</van-cell>
                  <!-- {{item.costName}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 10">
                <div class="item">
                  <div class="title requiredColum">开始时间</div>
                  <van-cell is-link>{{
                    item.beginDate
                  }}</van-cell>
                  <!-- {{item.leaveTime}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 10">
                <div class="item">
                  <div class="title requiredColum">结束时间</div>
                  <van-cell is-link>{{
                    item.endDate
                  }}</van-cell>
                  <!-- {{item.backTime}} -->
                </div>
              </van-grid-item>
              <van-grid-item
                v-if="
                  workflow == 9 && String(addForm.costName).indexOf('误餐费') != -1
                "
              >
                <div class="item">
                  <div class="title requiredColum">开始时间</div>
                  <van-cell is-link>{{
                    item.leaveTime
                  }}</van-cell>
                  <!-- {{item.leaveTime}} -->
                </div>
              </van-grid-item>
              <van-grid-item
                v-if="
                  workflow == 9 && String(addForm.costName).indexOf('误餐费') != -1
                "
              >
                <div class="item">
                  <div class="title requiredColum">结束时间</div>
                  <van-cell is-link>{{
                    item.backTime
                  }}</van-cell>
                  <!-- {{item.backTime}} -->
                </div>
              </van-grid-item>
              <van-grid-item
                v-if="
                  workflow == 9 && String(addForm.costName).indexOf('误餐费') == -1
                "
              >
                <div class="item">
                  <div class="title requiredColum">结束日期</div>
                  <van-cell is-link>{{
                    item.endDate 
                  }}</van-cell>
                  <!-- {{item.endDate}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 2 || workflow == 3">
                <div class="item">
                  <div class="title requiredColum">发生日期</div>
                  <van-cell is-link>{{
                    item.occurTime 
                  }}</van-cell>
                  <!-- {{item.occurTime}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 6">
                <div class="item">
                  <div class="title requiredColum">费用发生(月份)</div>
                  <van-cell is-link>{{
                    item.occurMonth 
                  }}</van-cell>
                  <!-- {{item.occurMonth}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 2">
                <div class="item">
                  <div class="title requiredColum">始发地</div>
                  <van-field
                    disabled
                    v-model="item.provenance"
                    placeholder=""
                  />
                  <!-- {{item.provenance}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 2">
                <div class="item">
                  <div class="title requiredColum">目的地</div>
                  <van-field
                    disabled
                    v-model="item.destination"
                    placeholder=""
                  />
                  <!-- {{item.destination}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 2">
                <div class="item">
                  <div class="title">外出事由</div>
                  <van-field
                    disabled
                    v-model="item.costDescription"
                    placeholder=""
                  />
                  <!-- {{item.forceUpdate}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 1">
                <div class="item">
                  <div class="title">仓位</div>
                  <van-field
                    disabled
                    v-model="item.classLevel"
                    placeholder=""
                  />
                  <!-- {{item.classLevel}} -->
                </div>
              </van-grid-item>
              <van-grid-item>
                <div class="item">
                  <div class="title requiredColum">
                    {{ workflow == 0 ? "预计金额" : "报销金额" }}
                  </div>
                  <van-field
                    v-model="item.amount"
                    placeholder=""
                    disabled
                  />
                  <!-- {{item.amountStr}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 0 || workflow == 1">
                <div class="item">
                  <div class="title">出行工具</div>
                  <van-cell is-link>{{
                    item.travelToolName 
                  }}</van-cell>
                  <!-- {{item.travelToolName}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 5">
                <div class="item">
                  <div class="title requiredColum">招待对象</div>
                  <van-field
                    disabled
                    v-model="item.guests"
                    placeholder=""
                  />
                  <!-- {{item.guests}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 5">
                <div class="item">
                  <div class="title requiredColum">招待人数</div>
                  <van-field
                    disabled
                    v-model="item.receptPerson"
                    placeholder=""
                  />
                  <!-- {{item.receptPerson}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 5">
                <div class="item requiredColum">
                  <div class="title">陪同人数</div>
                  <van-field
                    disabled
                    v-model="item.escortsPerson"
                    placeholder=""
                  />
                  <!-- {{item.escortsPerson}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 5">
                <div class="item">
                  <div class="title requiredColum">招待性质</div>
                  <van-cell is-link>{{
                    item.receptionNatureName 
                  }}</van-cell>
                  <!-- {{item.receptionNatureName}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 6 || workflow == 8">
                <div class="item">
                  <div class="title requiredColum">报销人</div>
                  <van-cell is-link>{{
                    item.reimEmployeeName 
                  }}</van-cell>
                  <!-- {{item.reimEmployeeName}} -->
                </div>
              </van-grid-item>
              <van-grid-item
                v-if="
                  workflow == 9 &&
                  String(addForm.costName).indexOf('生活用品') != -1
                "
              >
                <div class="item">
                  <div class="title requiredColum">发生季度</div>
                  <van-cell is-link>{{
                    item.occurQuarter 
                  }}</van-cell>
                </div>
              </van-grid-item>

              <van-grid-item v-if="workflow == 10">
                <div class="item">
                  <div class="title requiredColum">会议地点</div>
                  <van-field
                    disabled
                    v-model="item.meetingPlace"
                    placeholder=""
                    type="text"
                  />
                  <!-- {{item.count}} -->
                </div>
              </van-grid-item>

              <van-grid-item v-if="workflow == 10">
                <div class="item">
                  <div class="title requiredColum">人数</div>
                  <van-field
                    disabled
                    v-model="item.attendance"
                    placeholder=""
                    type="number"
                  />
                  <!-- {{item.count}} -->
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow == 7 || workflow == 8">
                <div class="item">
                  <div class="title requiredColum">额度可报销余额</div>
                  {{ item.remainQuotaStr }}
                </div>
              </van-grid-item>
              <van-grid-item v-if="workflow != 2">
                <div class="item">
                  <div class="title">费用说明</div>
                  <van-field
                    disabled
                    v-model="item.costDescription"
                    placeholder=""
                  />
                  <!-- {{item.costDescription}} -->
                </div>
              </van-grid-item>
            </van-grid>
          </div>
    </div>
      </van-swipe-item>
      <van-swipe-item>
        <div class="gridBox">
          <div
            class="tabContro van-hairline--bottom"
            v-for="(item, index) in addForm.fileVoList"
            :key="index"
          >
            <div class="tit">
              <svg-icon icon-class="fill" style="margin-right: 4px"></svg-icon
              >{{ item.fileName }}
            </div>
            <div
              class="del"
              style="color: blue"
              @click="
                $api.look({ filePath: item.filePath, fileName: item.fileName })
              "
            >
              查看
            </div>
            <div v-if="$route.query.approveType == 'approve'" class="del" @click="deleteFj(index)">删除</div>
          </div>
          <div class="add noCopy" onbeforecopy="return false" v-if="$route.query.approveType == 'approve'">
            <van-button @click="upload"
              ><svg-icon
                icon-class="shangchuan"
                style="margin-right: 4px"
              />上传文件</van-button
            >
          </div>
        </div>
      </van-swipe-item>
      <template #indicator>
        <div></div>
      </template>
    </van-swipe>

    <MyTitle title="关联借支单号" v-if="workflow == 3 && addForm.isBorrow"></MyTitle>
    <!-- <DocRelate @showPopup="showPopup"></DocRelate> -->
    <div class="gridBox" v-if="workflow == 3 && addForm.isBorrow" style="margin-bottom:40px;">
      <van-grid column-num="2">
        <van-grid-item>
          <div class="item">
            <van-cell class="title requiredColum" is-link>关联借支单号</van-cell>
            <div v-for="(item,index) in addForm.writeoffDetailEntityList" :key="index">{{item.applyNum}}</div>
          </div>
        </van-grid-item>
      </van-grid>
    </div>
    <div v-if="workflow == 3 && addForm.isBorrow">
      <div class="gridBox" v-for="(item,index) in addForm.writeoffDetailEntityList || []" :key="index">
        <div class="tabContro van-hairline--bottom">
          <div class="tit">借支单({{ index + 1 }})</div>
        </div>
        <van-grid column-num="2">
          <van-grid-item>
            <div class="item">
              <div class="title requiredColum">工作流名称</div>
              <van-field
                v-model="item.workflowName"
                disabled
              />
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="item">
              <div class="title requiredColum">单据编号</div>
              <van-field
                v-model="item.applyNum"
                disabled
              />
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="item">
              <div class="title requiredColum">借支类型</div>
              <van-field
                v-model="item.borrowTypeName"
                disabled
              />
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="item">
              <div class="title requiredColum">申请人</div>
              <van-field
                v-model="item.createUser"
                disabled
              />
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="item">
              <div class="title">借支金额</div>
              <van-field
                v-model="item.applyAmountStr"
                disabled
              />
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="item">
              <div class="title">剩余未冲销金额</div>
              <van-field
                v-model="item.remainAmountStr"
                disabled
              />
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="item">
              <div class="title requiredColum">本次冲销金额</div>
              <van-field
                v-model="item.writeOffAmountStr"
                disabled
              />
            </div>
          </van-grid-item>
          <van-grid-item>
            <div class="item">
              <div class="title">费用说明</div>
              <van-field
                v-model="item.costDescription"
                disabled
              />
            </div>
          </van-grid-item>
        </van-grid>
      </div>
    </div>


    <MyTitle title="审批流程"></MyTitle>
    <div class="steps" v-for="(item, index) in logList" :key="index">
      <div class="left">
        <svg-icon icon-class="yinzhang"></svg-icon>
        <div class="leftBorder"></div>
      </div>
      <div class="right">
        <div class="superior">
          <span>{{ item.operator }}</span>
          <span>{{ item.operationTime }}</span>
        </div>
        <div class="superiorData">
          <div style="width:30%;white-space: nowrap;" class="operation">{{ item.operation }}</div>
          <div class="text">
            {{item.note}}
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="steps">
      <div class="left">
        <svg-icon icon-class="feiji"></svg-icon>
        <div class="leftBorder"></div>
      </div>
      <div class="right">
        <div class="superior"></div>
        <div class="superiorData">
          <div class="img">
            <img src="" alt="" />
            <span><svg-icon icon-class="success"></svg-icon></span>
          </div>
          <div style="color: rgb(60, 60, 60)">*****</div>
          <div class="text">同意·14/1608:34</div>
        </div>
      </div>
    </div> -->
    <div class="btnBox" v-if="$route.query.type == 'approve'">
      <van-button class="no" :loading="approveLoading"  @click="approveFun(2)">退回</van-button>
      <van-button class="ok" :loading="approveLoading" @click="approveFun(1)">同意</van-button>
    </div>
    <!-- <div class="btnBox2" v-if="$route.query.type == 'detail' && addForm.status == 2">
      <button @click="edit">修改提交</button>
    </div> -->
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  components: {},
  mounted() {
    this.$bus.$on("bookingSubsidiaryFun", (obj) => {
      this.bookingSubsidiaryObj = {
        bookingSubsidiary: obj.subsidiary, // 入账子公司
        bookingSubsidiaryCode: obj.easCode, //入账子公司编码
      };
      this.addForm.bookingSubsidiary = obj.subsidiary;
      this.addForm.bookingSubsidiaryCode = obj.easCode;
    });
  },
  computed: {
    id() {
      this.detailId = this.$route.query.id;
      return this.$route.query.id;
    },
    workflow() {
      return this.addForm.workflow;
    },
    type() {
      this.detailType = this.$route.query.type;
      return this.$route.query.type;
    },
  },
  watch: {
    // active(newVal){
    //   this.tabClick(newVal)
    // },
    detailId(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getData();
      }
    },
    detailType(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getData();
      }
    },
  },
  created() {
    this.getData();
    // 0', '待提交',
    // 3', '待审批',
    // 1', '预审通过',
    // 2', '预审不通过
    // 4', '审批中',
    // 5', '属地审核',
    // 6', '汇款中',
    // 7', '汇款成功',
    // 8', '汇款失败',
  },
  data() {
    return {
      approveLoading:false,
      sf:"",
      md:"",
      detailType: "",
      detailId: "",
      addForm: {
        writeoffDetailEntityList:[]
      },
      detailInformationData: [],
      active:"发票夹",
      logList: [],
      bookingSubsidiaryObj: {
        bookingSubsidiary: "", // 入账子公司
        bookingSubsidiaryCode: "", //入账子公司编码
      },
      swiperIndex:0,
    };
  },
  methods: {
    tabClick(name){
      if(this.workflow == 0 ){
        if(name == "明细信息"){this.$refs.swiper.swipeTo(0)}
        if(name == "附件信息"){this.$refs.swiper.swipeTo(1)}
      }
      if(this.workflow == 4 ){
        if(name == "附件信息"){this.$refs.swiper.swipeTo(0)}
      }
      if(this.workflow != 0 && this.workflow != 4){
        if(name == "发票夹"){this.$refs.swiper.swipeTo(0)}
        if(name == "明细信息"){this.$refs.swiper.swipeTo(1)}
        if(name == "附件信息"){this.$refs.swiper.swipeTo(2)}
      }
    },
    swiperChange(index){
      this.swiperIndex = index
      if(this.workflow == 0 ){
        if(index == 0){this.active = "明细信息"}
        if(index == 1){this.active = "附件信息"}
      }
      if(this.workflow == 4 ){
        if(index == 0){this.active = "附件信息"}
      }
      if(this.workflow != 0 && this.workflow != 4){
        if(index == 0){this.active = "发票夹"}
        if(index == 1){this.active = "明细信息"}
        if(index == 2){this.active = "附件信息"}
      }
    },
    deleteFj(index) {
      this.addForm.fileVoList = this.addForm.fileVoList.filter(
        (item, ind) => ind != index
      );
      this.$forceUpdate();
    },
    upload() {
      let ipt = document.createElement("input");
      ipt.type = "file";
      ipt.multiple = "multiple";
      ipt.click();
      ipt.onchange = () => {
        let params = new FormData();
        params.append("files", ipt.files[0], ipt.files[0].name);
        this.$api
          .uploadPost(
            `/zuul/payment/center/upload/fileMultiple?token=${Cookies.get(
              "payapp_token"
            )}`,
            params
          )
          .then((res) => {
            if (res.repCode == "0000") {
              let arr = res.repData.map((item) => {
                return {
                  filePath: item.attName,
                  fileName: item.fileName,
                };
              });
              if (this.addForm.fileVoList) {
                this.addForm.fileVoList = [...this.addForm.fileVoList, ...arr];
              } else {
                this.addForm.fileVoList = arr;
              }
              this.$forceUpdate();
            }
          });
      };
    },
    getData() {
      this.$api
        .post("/payment/center/reimburse/getDetail", {
          reqData: {
            id: this.$route.query.id,
          },
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.addForm = res.repData;
            if (this.addForm.itinerary) {
              let arr = this.addForm.itinerary.split("-");
              this.sf = arr[0];
              // this.tjone = arr[1];
              // this.tjtwo = arr[2];
              this.md = arr[3];
            }
            this.bookingSubsidiaryObj.bookingSubsidiary = this.addForm.bookingSubsidiary
            this.bookingSubsidiaryObj.bookingSubsidiaryCode = this.addForm.bookingSubsidiaryCode
            if (res.repData.domesticVoList) {
              this.detailInformationData = res.repData.domesticVoList;
            }
            if (res.repData.cityVoList) {
              this.detailInformationData = res.repData.cityVoList;
            }
            if (res.repData.pettyVoList) {
              this.detailInformationData = res.repData.pettyVoList;
            }

            if (res.repData.businessVoList) {
              this.detailInformationData = res.repData.businessVoList;
            }
            if (res.repData.houseCarVoList) {
              this.detailInformationData = res.repData.houseCarVoList;
            }
            if (res.repData.phoneVoList) {
              this.detailInformationData = res.repData.phoneVoList;
            }
            if (res.repData.carVoList) {
              this.detailInformationData = res.repData.carVoList;
            }
            if (res.repData.welfareVoList) {
              this.detailInformationData = res.repData.welfareVoList;
            }
            if (res.repData.meetingVoList) {
              this.detailInformationData = res.repData.meetingVoList;
            }
            if (res.repData.mealVoList) {
              this.detailInformationData = res.repData.mealVoList;
            }
            if (res.repData.licenseVoList) {
              this.detailInformationData = res.repData.licenseVoList;
            }
            if (res.repData.loanList) {
              this.addForm.writeoffDetailEntityList = JSON.parse(JSON.stringify(res.repData.loanList));
            }
          }
        });
      this.$api
        .post("/payment/center/reimburse/logList", {
          reqData: {
            reimburseId: this.$route.query.id,
          },
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.logList = res.repData;
          }
        });
    },
    approveFun(status) {
      let path = "/payment/center/reimburse/approval";
      if (this.$route.query.approveType == "receiptApproval") {
        path = "/payment/center/reimburse/collectApproval";
      }
      let files = []
      if(this.$route.query.approveType == "approve"){
        files = this.addForm.fileVoList
      }
      this.approveLoading = true
      this.$api
        .post(path, {
          reqData: {
            id: this.$route.query.id,
            status,
            opinion: "",
            files,
            ...this.bookingSubsidiaryObj,
          },
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.$notify({
              type: "success",
              message: "操作成功",
            });
            this.$router.go(-1);
          }
          this.approveLoading = false
        }).catch(()=>{
          this.approveLoading = false
        })
    },
  },
};
</script>

<style lang="scss">
.approve {
  height: 100%;
  .van-swipe{
    background: #fff;
  }
  .approvetitle {
    color: #1afa29;
  }
  .van-swipe__track{
    background: #fff;
  }
  .dataBox {
    background: #fff;
    padding: 10px 20px 0;
    .item {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      .label {
        width: 100px;
      }
    }
  }
  .van-tabs__line {
    width: calc(100% / 3);
  }
  .steps {
    display: flex;
    padding: 0 10px;
    background: #fff;
    overflow: hidden;
    .left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .leftBorder {
        width: 1px;
        // height: 50px;
        flex: 1;
        background: rgb(57, 117, 197);
        margin: 10px 0;
      }
    }
    .right {
      flex: 1;
      padding-right: 20px;
      padding-left: 10px;
      padding-bottom: 10px;
      overflow: hidden;
    }
  }
  .superior {
    color: rgb(69, 69, 69);
    display:flex;
    justify-content: space-between;
    align-items: center;
  }
  .superiorData {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    overflow: hidden;
    >div{
      height: 100%;
    }
    .text {
      flex: 1;
      color: rgb(142, 142, 142);
      word-wrap:break-word; 
      word-break:break-all; 
      overflow: hidden;
      text-align: left;
      padding-right:0px;
    }
  }
  .btnBox2 {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 30px;
    background: #fff;
    margin-top: 20px;
    button {
      outline: none;
      width: 100%;
      height: 40px;
      background: #fff;
      border: 1px solid rgb(39, 141, 216);
      color: rgb(39, 141, 216);
    }
  }
  .btnBox {
    display: flex;
    justify-content: space-between;
    padding: 20px 30px;
    background: #fff;
    margin-top: 20px;
    button {
      width: 140px;
      height: 34px;
      outline: none;
      border-radius: 5px;
    }
    .no {
      background: #fff;
      border: 1px solid rgb(228, 46, 22);
      color: rgb(228, 46, 22);
    }

    .ok {
      background: rgb(57, 117, 197);
      color: #fff;
      border: 1px solid rgb(57, 117, 197);
    }
  }
  .gridBox {
    .add {
      padding: 10px 0;
      button {
        width: 100%;
        border-radius: 5px;
        background: #fff;
        font-size: 12px;
      }
    }
    // background: #fff;
    .tabContro {
      display: flex;
      justify-content: space-between;
      padding: 10px 20px;
      font-size: 14px;
      background: #fff;
      .tit {
        flex: 1;
        color: rgb(109, 113, 132);
        white-space: nowrap;
        overflow: hidden;
      }
      .del {
        color: red;
        white-space: nowrap;
        padding-left: 10px;
      }
    }
    .title {
      font-size: 14px;
      color: rgb(109, 113, 132);
      margin-bottom: 4px;
    }
    .van-cell {
      padding: 0 0 !important;
    }
    .van-field__control::placeholder {
      color: rgb(155, 159, 171) !important;
    }
    .item2 {
      display: flex;
      align-items: center;
      padding: 10px;
      background: #fff;
      .label {
        width: 100px;
      }
    }
    .item {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      padding: 0 10px;
      .van-cell {
        padding: 0 0 !important;
      }
      .van-cell__value--alone {
        color: rgb(155, 159, 171);
      }
    }
  }
  .essentialInformation {
    display: flex;
    flex-wrap: wrap;
    div {
      width: 50%;
      flex-shrink: 0;
      flex-wrap: 0;
      display: flex;
      align-items: center;
      div {
        width: 50%;
        margin: 10px 0;
      }
      .label {
        display: flex;
        justify-content: flex-end;
        font-size: 13px;
        color: rgb(109, 113, 132);
      }
      .text {
        color: rgb(44, 44, 44);
        padding-left: 10px;
        font-size: 13px;
      }
    }
  }
}
</style>